/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CloudDownloadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABr0lEQVR4nO2Vv0vDUBDH4y9wkS5apejfElxUtO/uZXi9EwvdOhXFxYIIVXDxP7Lq4KQoitXqpqsuKhZFcFJek7ZJm6Rp09GDR8gj+XzvvvdyMYz/GGSYudw4SNoQSBcg6Qsk1QD5XEgq5PP5sVhwRJoTku5A8q/vQq4sKzUTPVOL1wHpFAAm9H0o3FlC0k3XSixrbdYNW1JqStvSDe4SKYRm3p6pUiphex5NQPckUACANztegMy8QP6MLCCpFiggJF11lswP0eEhAqZpjgrk795g7GMRPflnj7wfGy6dqpF2vd5bvNI/jH8E8hYAp/QSSEW9l5a00BKQfBIj26JmlEqlYcMwhmw3qCgkHbrteevbEuBUPUnkiv7QnNOYAknvboGP/hrKLy4X6nsu5qPrePJxL56D5B39xSulRoIEPKEb0oPn236MUAGnpL0oAkqphO05nQHytWVlk+0C9fmFXAZJBx4RxMwiIB0JpNeA7J8bJ0XDnT5U7YFoP6MFm/MMuWz0G0LwdHOMIFdbidC9c71Np1cnjThhWdmkF94UiQ8PFhkgvBHaLkC+1P+Cdvgf+e4/v5kPCVAAAAAASUVORK5CYII=)
 */
export const CloudDownloadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M18.3 23.7a1 1 0 0 0 1.4 0l4-4a1 1 0 0 0-1.4-1.4L20 20.58V14.9a1 1 0 0 0-2 .1v5.59l-.73-.73-1.56-1.57a1 1 0 0 0-1.42 1.42l4 4Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M15.31 16.02a3 3 0 0 0-3.3 3.3c.04.34-.2.68-.55.68H6a5 5 0 0 1-3.2-8.85c.12-.1.2-.24.2-.4a6 6 0 0 1 4.55-5.57c.36-.1.64.26.57.62a6.03 6.03 0 0 0 .3 3.4c.12.32.58.15.58-.2a5.98 5.98 0 0 1 6-6 6 6 0 0 1 5.83 7.44c-.06.22.03.45.2.59a5 5 0 0 1 1.92 4.65c-.02.19-.19.32-.38.35-.28.04-.57-.16-.57-.45V15a3 3 0 0 0-6 0v.46c0 .35-.34.6-.69.56Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
